import { ReactNode } from "react";
import Divider from "@mui/material/Divider";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { formatNumber } from "../../utils";
import { VAT_RATE_PERCENT } from "../../utils/vat";
import { DecimalValue } from "../../types/credit-debit-note.type";

interface NoteTotalsSummaryProps {
  /** null while the original invoice's value is not known yet. */
  originalValue: DecimalValue | null;
  correctValue: DecimalValue | null;
  difference: DecimalValue;
  vatAmount: DecimalValue;
  grandTotal: DecimalValue;
}

function TotalsRow({
  label,
  value,
  isGrandTotal = false,
}: Readonly<{ label: ReactNode; value: DecimalValue | null; isGrandTotal?: boolean }>) {
  return (
    <Stack direction="row" justifyContent="space-between" alignItems="baseline" py={0.5}>
      <Typography
        variant={isGrandTotal ? "subtitle1" : "body2"}
        fontWeight={isGrandTotal ? 700 : 400}
      >
        {label}
      </Typography>
      <Typography
        variant={isGrandTotal ? "h6" : "body2"}
        fontWeight={isGrandTotal ? 700 : 500}
        color={isGrandTotal ? "primary" : "text.primary"}
      >
        {formatNumber(value)}
      </Typography>
    </Stack>
  );
}

/** The totals block in the order the printed note lists it. */
export default function NoteTotalsSummary({
  originalValue,
  correctValue,
  difference,
  vatAmount,
  grandTotal,
}: Readonly<NoteTotalsSummaryProps>) {
  return (
    <Stack>
      <TotalsRow label="มูลค่าสินค้าตามใบกำกับภาษีเดิม" value={originalValue} />
      <TotalsRow label="มูลค่าสินค้าที่ถูกต้อง" value={correctValue} />
      <TotalsRow label="ผลต่าง" value={difference} />
      <TotalsRow label={`ภาษีมูลค่าเพิ่ม ${VAT_RATE_PERCENT}%`} value={vatAmount} />
      <Divider sx={{ my: 1 }} />
      <TotalsRow label="จำนวนเงินรวมทั้งสิ้น" value={grandTotal} isGrandTotal />
    </Stack>
  );
}
